<script setup>
import ServicePricingCards from '@/components/pricing/ServicePricingCards.vue'

/**
 * LandingPricing - Sección de pricing para la Home
 *
 * Wrapper de ServicePricingCards con configuración compacta.
 * Precios y servicios definidos en utils/constants/services.js
 */
</script>

<template>
  <div id="precios">
    <!-- Section Header -->
    <div class="max-w-6xl mx-auto px-6 pt-24 pb-8 text-center">
      <span class="text-sm font-semibold text-accent-600 uppercase tracking-widest mb-4 block">Precios</span>
      <h2 class="text-4xl md:text-5xl font-bold text-text-primary mb-6">
        Pago único, resultados reales
      </h2>
      <p class="text-xl text-text-secondary max-w-xl mx-auto mb-12">
        Sin suscripciones. Cumplimiento legal garantizado.
      </p>
    </div>

    <!-- Service Pricing Cards -->
    <ServicePricingCards
      :show-description="true"
      :features-limit="3"
      cta-text="Comenzar"
      :direct-to-register="true"
      :show-guarantee="true"
      :compact="true"
    />
  </div>
</template>

<style scoped>
@reference "../../assets/styles/main.css";
</style>
